"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconClock = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("../Icon/SvgWrapper");
const IconClock = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  d: "M10.5 1.207C4.71 1.207 0 5.828 0 11.512c0 5.68 4.71 10.3 10.5 10.3s10.5-4.62 10.5-10.3c0-5.684-4.71-10.305-10.5-10.305zm6.04 11.336H9.45V5.328c.034-.562.394-.844 1.077-.844.68 0 1.024.278 1.024.844v5.152h4.988c.578.086.871.438.871 1.051 0 .614-.293.95-.87 1.012zm0 0"
}));
exports.IconClock = IconClock;
//# sourceMappingURL=IconClock.js.map